<script setup lang="ts">
import Spinner from '@components/Spinner.vue';
import { apiRestoreSelectionItem } from '@api/selectionItem/apiSelectionItem';
import { trans } from '@elements/translation';
import { useLoading } from '@composables/useLoading.ts';
import IconArrowCounterClockwiseFill from '@icons/ph_arrow-counter-clockwise-fill_black.svg';
import Icon from '@components/Icon.vue';
import { useSelectionItemStore } from '@organisms/offer/selection-items/stores/useSelectionItemStore';

const props = defineProps<{ selectionItemId: number }>();

const { isLoading, stopLoading, startLoading } = useLoading();

const restoreSelectionItem = async (): Promise<void> => {
  startLoading();

  const data = await apiRestoreSelectionItem(props.selectionItemId);

  if (data) {
    useSelectionItemStore().restoreSelectionItem({
      itemId: props.selectionItemId,
      order: data.displayOrder,
    });
  }

  stopLoading();
};
</script>

<template>
  <button
    class="selection-item-restore-button"
    :disabled="isLoading"
    @click="restoreSelectionItem"
  >
    <span>
      {{ trans('selection_item.removed.item.button.restore') }}
    </span>

    <spinner v-if="isLoading" />

    <Icon v-else :svg="IconArrowCounterClockwiseFill" />
  </button>
</template>

<style scoped lang="scss">
@use '@styles/variables' as *;
@use '@styles/mixins' as *;

.selection-item-restore-button {
  width: fit-content;
  padding: rem(8) rem(8) rem(8) rem(12);
  display: flex;
  align-items: center;
  gap: rem(8);
}
</style>
